import { useCallback } from "react";
const defaultMatchFilter = (option, getOptionLabel, searchValue) => getOptionLabel(option).toLocaleLowerCase().includes(searchValue.toLocaleLowerCase());
function useFilterOptions(matchFilter = defaultMatchFilter) {
  return useCallback(
    (options, state) => {
      return options.filter((option) => matchFilter(option, state.getOptionLabel, state.inputValue));
    },
    [matchFilter]
  );
}
export {
  useFilterOptions
};
//# sourceMappingURL=useFilterOptions.js.map
